var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightningBoltDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5608 1.25555C14.0603 1.41302 14.4 1.87627 14.4 2.40004V8.40004L19.2 8.40004C19.6475 8.40004 20.0577 8.64899 20.2644 9.04587C20.471 9.44275 20.4397 9.92163 20.1831 10.2882L11.7831 22.2882C11.4827 22.7173 10.9388 22.902 10.4392 22.7445C9.93971 22.5871 9.60001 22.1238 9.60001 21.6L9.60001 15.6H4.80001C4.35256 15.6 3.94227 15.3511 3.73564 14.9542C3.529 14.5573 3.56034 14.0784 3.81693 13.7119L12.2169 1.71188C12.5173 1.2828 13.0612 1.09809 13.5608 1.25555Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBoltDark);
export default __webpack_public_path__ + "static/media/lightningBoltDark.79544e9dc344b69e33433c266e93a6b7.svg";
export { ForwardRef as ReactComponent };